import { Check, Loader2, WifiOff } from "lucide-react";
import { cn } from "@/lib/utils";
import type { SyncStatus } from "../types";

const statusStyles: Record<SyncStatus, string> = {
  connecting: "bg-neutral-100 text-neutral-700 ring-neutral-200",
  live: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  saving: "bg-neutral-100 text-neutral-700 ring-neutral-200",
  offline: "bg-amber-50 text-amber-800 ring-amber-200",
  error: "bg-red-50 text-red-700 ring-red-200",
};

export function StatusBadge({ status, clients }: { status: SyncStatus; clients: number }) {
  const label =
    status === "live" && clients > 1
      ? `Live ${clients}`
      : {
          connecting: "Connecting",
          live: "Live",
          saving: "Saving",
          offline: "Offline",
          error: "Error",
        }[status];

  const icon =
    status === "live" ? (
      <Check size={14} />
    ) : status === "offline" || status === "error" ? (
      <WifiOff size={14} />
    ) : (
      <Loader2 className="animate-spin" size={14} />
    );

  return (
    <span
      className={cn(
        "inline-flex min-h-8 items-center gap-2 rounded-full px-3 text-sm font-medium ring-1",
        statusStyles[status],
      )}
    >
      {icon}
      {label}
    </span>
  );
}
